import { initializeApp } from "firebase/app";
import { initializeAnalytics, isSupported, logEvent } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

let analyticsPromise;

function getAnalyticsInstance() {
  if (!firebaseConfig.measurementId) {
    return Promise.resolve(null);
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => (
        supported
          ? initializeAnalytics(app, { config: { send_page_view: false } })
          : null
      ))
      .catch(() => null);
  }

  return analyticsPromise;
}

export function trackPageView(location) {
  return getAnalyticsInstance().then((analytics) => {
    if (!analytics) {
      return;
    }

    logEvent(analytics, "page_view", {
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_title: document.title,
    });
  });
}

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);